import { render, staticRenderFns } from "./WorkshopManager.vue?vue&type=template&id=5c63c158&"
import script from "./WorkshopManager.vue?vue&type=script&lang=js&"
export * from "./WorkshopManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports